// Chat Configuration
export const chatConfig = {
  // Backend URL - Update this to match your backend server
  backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080',
  
  // Socket.io configuration
  socketConfig: {
    transports: ['websocket', 'polling'],
    timeout: 10000,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  },
  
  // API timeout settings
  apiTimeout: 10000,
  
  // Chat settings
  chatSettings: {
    maxMessageLength: 1000,
    typingIndicatorTimeout: 1000,
    messageRetryAttempts: 3,
    autoScrollDelay: 100,
  },
  
  // Feature flags
  features: {
    enableTypingIndicators: true,
    enableReadReceipts: true,
    enablePushNotifications: true,
    enableMessageSearch: false,
    enableFileUpload: false,
  }
};

export default chatConfig;
